import { RegionCode } from '@aviv-estimation-funnel/estimation-data-models/enums';

import { Filter } from '../../filter';
import type { PhoneNumber } from '../../phone-number';
import { ErrorType, FieldValues } from '../../types';

export class AcceptedCountryCodePhoneNumberFilter implements Filter<PhoneNumber> {
    constructor(public readonly acceptedCountryCodes: Array<RegionCode>) {}

    async validate(fieldValue: PhoneNumber, otherFields: FieldValues): Promise<Array<ErrorType>> {
        if (
            fieldValue.regionCode !== undefined &&
            !this.acceptedCountryCodes.map((cc) => cc.toString()).includes(fieldValue.regionCode)
        ) {
            return [
                {
                    code: 'unsupportedCountryCode',
                    reason: `Country code should be in ${this.acceptedCountryCodes.join(', ')}`,
                },
            ];
        }

        return [];
    }
}
